





















import { Component, Vue } from "vue-property-decorator"

const isSupportedWebShareAPI = !!navigator.share

const toStringFromObj = (obj: { [x: string]: any }) => {
  let array: Array<string> = []
  for (const key in obj) {
    const value = obj[key]
    const str = typeof value === "string" ? `"${value}"` : value
    array.push(`\n    ${key}: ${str}`)
  }
  return `{${array.join(",")}\n}`
}

type Option = { url: string } | { text: string } | { title: string }
interface AAA {
  name: string
  option: Option
}

@Component({
  filters: {
    toStringFromObj
  }
})
export default class App extends Vue {
  isSupportedWebShareAPI = isSupportedWebShareAPI

  values: Array<AAA> = [
    {
      name: "タイトルのみ",
      option: { title: "Hello WebShareAPI!" }
    },
    {
      name: "テキストのみ",
      option: { text: "Hello WebShareAPI!(Text)" }
    },
    {
      name: "このサイトのURLのみ",
      option: { url: location.href }
    },
    {
      name: "他のサイトのURLのみ",
      option: { url: "https://qiita.com/katsuya_U" }
    },
    {
      name: "タイトルとテキスト",
      option: { title: "Title", text: "Text" }
    },
    {
      name: "タイトルとURL",
      option: { title: "Title", url: location.href }
    },
    {
      name: "テキストとURL",
      option: { text: "Text", url: location.href }
    },
    {
      name: "タイトルとテキストとURL",
      option: { title: "Title", text: "Text", url: location.href }
    }
  ]

  handleShareClick(option: Option) {
    navigator.share!(option)
      .then(p => {
        console.log("success!", p)
      })
      .catch(e => {
        console.log("error!", e)
      })
  }
}
